
import { Component, Vue } from 'vue-property-decorator'

import UIkit from 'uikit'

@Component({})
export default class ShareButton extends Vue {
  private shareOnFacebook () {
    window.open(this.shareLink, '_blank')
  }

  get shareLink (): string {
    const pageUrl = window.location.href.replace(/\/refactor\//g, '/') // remove refactor from link for prerender SEO tags with PHP
    return `https://www.facebook.com/dialog/share?app_id=278195127257803&display=popup&href=${encodeURIComponent(pageUrl)}&amp;src=sdkpreparse`
  }

  async copyLink () {
    if (navigator.share) {
      navigator.share({
        title: 'Mein Rally Team',
        url: window.location.href
      })
    } else {
      try {
        const success = navigator.clipboard.writeText(window.location.href)
      } catch (ex) {
        console.error('Async: Could not copy text: ')
      }
    }
    UIkit.notification({
      message: 'Link kopiert!',
      status: 'success',
      timeout: 5000,
      pos: 'bottom-center'
    })
  }
}

